import {uploadFormComponents as baseUploadFormComponents} from '@modifi/plugin-documents'

import DocumentTypeActionsCol from './DocumentTypeActionsCol'

const NoopComponent = (): null => null

export const uploadFormComponents = {
  documentTypeHeadlineCol: NoopComponent,
  existingFilesList: NoopComponent,
  fileQueueContainer: NoopComponent,
  fileQueueEntry: NoopComponent,
  documentTypeRow: baseUploadFormComponents.DocumentTypeRow,
  documentTypeActionsCol: DocumentTypeActionsCol,
}
